import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export interface AuthUser {
  sub: string
  email: string
  role: 'COMPANY' | 'PROVIDER'
  companyType?: 'ENTERPRISE' | 'TRAINING_CENTER'
  isCnpas?: boolean
  exp: number
  iat: number
}

export function useAuth(requiredRole?: 'COMPANY' | 'PROVIDER') {
  const navigate = useNavigate()
  const [user, setUser] = useState<AuthUser | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('velink_token')

    if (!token) {
      navigate('/connexion', { replace: true })
      setLoading(false)
      return
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1])) as AuthUser

      if (payload.exp * 1000 < Date.now()) {
        localStorage.removeItem('velink_token')
        navigate('/connexion', { replace: true })
        setLoading(false)
        return
      }

      if (requiredRole && payload.role !== requiredRole) {
        navigate('/connexion', { replace: true })
        setLoading(false)
        return
      }

      setUser(payload)
    } catch {
      localStorage.removeItem('velink_token')
      navigate('/connexion', { replace: true })
    } finally {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function logout() {
    localStorage.removeItem('velink_token')
    navigate('/connexion')
  }

  return { user, loading, logout }
}
